import NeedsActionWidget from './NeedsActionWidget';
import MyTodosWidget from './MyTodosWidget';
import AwaitingApprovalWidget from './AwaitingApprovalWidget';
import DeliveriesReviewWidget from './DeliveriesReviewWidget';
import MyLeaveWidget from './MyLeaveWidget';
import TeamOutThisWeekWidget from './TeamOutThisWeekWidget';
import TeamLeaveCalendarWidget from './TeamLeaveCalendarWidget';
import QuickActionsWidget from './QuickActionsWidget';
import PinnedObjectWidget from './PinnedObjectWidget';
import ModulesWidget from './ModulesWidget';
import WaitingOnOthersWidget from './WaitingOnOthersWidget';
import AssignedDispatchesWidget from './AssignedDispatchesWidget';
import DeadlinesWidget from './DeadlinesWidget';
import MyDealsWidget from './MyDealsWidget';
import MyEnquiriesWidget from './MyEnquiriesWidget';
import HamsterBriefWidget from './HamsterBriefWidget';
import ShipmentOverviewWidget from './ShipmentOverviewWidget';
import RecapsWidget from './RecapsWidget';
import InvoicesWidget from './InvoicesWidget';
import PartnersWidget from './PartnersWidget';

// Widget type (as returned by /api/dashboard/my-desk/catalog/) to body component.
const WIDGET_BODIES = {
  needs_action: NeedsActionWidget,
  my_todos: MyTodosWidget,
  awaiting_my_approval: AwaitingApprovalWidget,
  deliveries_for_review: DeliveriesReviewWidget,
  my_leave: MyLeaveWidget,
  team_out_this_week: TeamOutThisWeekWidget,
  team_leave_calendar: TeamLeaveCalendarWidget,
  quick_actions: QuickActionsWidget,
  modules: ModulesWidget,
  waiting_on_others: WaitingOnOthersWidget,
  assigned_dispatches: AssignedDispatchesWidget,
  deadlines_14d: DeadlinesWidget,
  my_deals: MyDealsWidget,
  my_enquiries: MyEnquiriesWidget,
  hamster_brief: HamsterBriefWidget,
  // Module lists (client's starting boards)
  shipment_overview: ShipmentOverviewWidget,
  my_deliveries: ShipmentOverviewWidget,
  enquiries_open: MyEnquiriesWidget,
  recaps_active: RecapsWidget,
  invoices_by_status: InvoicesWidget,
  crm_partners: PartnersWidget,
};

export const getWidgetBody = (type) => {
  if (typeof type === 'string' && type.startsWith('pinned_')) return PinnedObjectWidget;
  return WIDGET_BODIES[type] || null;
};

export default WIDGET_BODIES;
